import DEFAULT_THEME from '@maas-components/styles'
import styled from 'styled-components'
import { Button, Box } from 'core/components/Core/index'

export const VideoBox = styled(Box)`
  position: relative;
`
export const DeleteButton = styled(Button)`
  padding: 0;
  position: absolute;
  right: 3px;
  margin-top: 2px;
  border-radius: 3px;
  background-color: ${DEFAULT_THEME.palette.grey[200]};
  min-width: 15px;
  color: ${DEFAULT_THEME.palette.error.main};
  :hover {
    background-color: ${DEFAULT_THEME.palette.grey[400]};
  }
`
